module.exports = __webpack_public_path__ + "media/promo/courses/images/julia-66622e4eb6e9de380873016bef1fe337.png";